import React, { useContext } from 'react';
import { getPageSameType } from '../../utils/util';
import { getPendantColor } from '../../utils/color';
import { style } from '../../utils/image';
import RootStore from '../../store/RootStore';
import { ThemeContext } from '../../store/ThemeProvider';

export interface INormalButton {
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
  rootStore?: RootStore;
  children?: any;
}

const NormalButton = (props: INormalButton) => {
  const { backgroundColor, mainColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);

  return (
    <div className={`pendant-row ${props.className || ''}`}>
      <div
        className="pendent-normal normal-button"
        onClick={props.onClick}
        style={{
          color: pendantIconColor,
          backgroundColor: pendantBgColor,
          ...props.style
        }}
      >
        {props.children}
      </div>
    </div>
  );
};

export default NormalButton;
